import React from 'react';
import { colorTextStatusError } from '@cloudscape-design/design-tokens';

interface RequiredFieldLabelProps {
  label: string;
  required?: boolean;
  /** Color of the asterisk (default: Cloudscape error/red token) */
  indicatorColor?: string;
}

const RequiredFieldLabel: React.FC<RequiredFieldLabelProps> = ({
  label,
  required = true,
  indicatorColor = colorTextStatusError,
}) => {
  return (
    <span>
      {label} {required && <i style={{ color: indicatorColor }}>*</i>}
    </span>
  );
};

export default RequiredFieldLabel;
